export const PushNotificationAlert = () => {
  return null;
};
